import styled from 'styled-components';

import {Icon} from '../../components/Icon/Icon';
import {scToTwColour} from '../../theme';

const ListItem = styled.li`
  width: min-content;
  min-width: 100%;
  padding: 0.5em;
  line-height: 1.4em;
  border-top: 1px solid ${scToTwColour('theme.colours.slate6')};
  list-style: none;
  background-color: ${scToTwColour('theme.colours.slate1')};
  color: ${scToTwColour('theme.colours.slate12')};
  pointer-events: all;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    background-color: ${scToTwColour('theme.colours.blue10')};
    color: ${scToTwColour('theme.colours.white')};
  }
  &:hover,
  &:hover + & {
    border-top: 1px solid ${scToTwColour('theme.colours.blue10')};
  }

  // &:first-of-type {
  //   border-top: 0;
  //   border-top-left-radius: 0.4em;
  //   border-top-right-radius: 0.4em;
  // }

  // &:last-of-type {
  //   border-bottom-left-radius: 0.4em;
  //   border-bottom-right-radius: 0.4em;
  // }

  ._icon {
    margin-right: 0.8em;
  }
`;
const List = styled.ul`
  position: absolute;
  top: 95%;
  left: 0;
  height: auto;
  min-width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  z-index: 2000;
  overflow: hidden;
  border-radius: 0.4em;
`;

export const FloatingList = {
  ListItem,
  List,
};
